export type PrevalidationFlagBadges = {
  suspended: boolean;
  accessByGuard: boolean;
};

/**
 * Sólo importan las prevalidaciones vigentes ("status" resuelto por el backend, ver
 * AuthorizationsSection): una suspensión o un paso previo por portería en una prevalidación vencida
 * no debería alertar al guardia en el paso de datos personales.
 *
 * No se filtra por `_source === "prevalidation"` a secas: `refetchAuthorizations` (al tocar un
 * "tipo de autorización") y los flujos de egreso por prevalidación no taggean ese `_source` como sí
 * hace la búsqueda inicial. Se usa el mismo criterio que AuthorizationsSection para reconocer una
 * prevalidación: todo lo que no venga explícitamente marcado como invite/authorization.
 */
export const computePrevalidationFlagBadges = (
  authorizations?: any[] | null
): PrevalidationFlagBadges => {
  const validPrevalidations = (authorizations || []).filter(
    (auth: any) =>
      auth &&
      auth._source !== "invite" &&
      auth._source !== "authorization" &&
      auth.status === "valid"
  );

  return {
    suspended: validPrevalidations.some((auth: any) => Boolean(auth?.suspended)),
    accessByGuard: validPrevalidations.some((auth: any) => Boolean(auth?.accessByGuard)),
  };
};
